<div class="container-box details-box">
  <div class="box-body">
    <div class="row no-margin">
      <div class="col-md-6 box-content border-right">
        <h6 class="title" i18n>Channel Information</h6>
        <div class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Channel"
                i18n-placeholder
                [value]="channel?.friendlyName"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input type="text" matInput placeholder="Type" i18n-placeholder value="API" disabled />
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="isHomeAway" class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Property Name"
                i18n-placeholder
                [value]="connection?.propertyNameView"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Date Linked"
                i18n-placeholder
                [value]="config?.date_enabled | epoch"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block has-icon">
              <input
                type="text"
                matInput
                placeholder="Rental"
                i18n-placeholder
                [value]="config?.rental?.name"
                disabled
              />
              <a href="javascript:;" (click)="rentalOverlay.emit(config?.rental)" class="rental-link">
                <i class="fal fa-home"></i>
              </a>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-6 box-content">
        <h6 class="title" i18n>Connection Information</h6>
        <div *ngIf="!isHomeAway" class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Channel ID"
                i18n-placeholder
                [value]="config?.channel_rental_id || ''"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="isHomeToGo" class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Connection Approval Status"
                i18n-placeholder
                [value]="config?.channel_live ? 'Live' : 'Pending'"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Channel URL"
                i18n-placeholder
                [value]="config?.channel_url || ''"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-11">
            <mat-form-field class="mat-block">
              <input
                type="text"
                matInput
                placeholder="Last Sync"
                i18n-placeholder
                [value]="config?.last_sync | epoch"
                disabled
              />
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="isHomeToGo" class="row">
          <div class="col-sm-11">
            <ng-container *ngIf="config?.rental?.taxes?.length > 0">
              <mat-slide-toggle
                (click)="$event.stopPropagation()"
                [id]="config?.pkey"
                [checked]="config?.status === 1"
                (change)="toggle.emit(config)"
                i18n
                >Status: {{ config?.status === 1 ? 'Active' : 'Inactive' }}</mat-slide-toggle
              >
            </ng-container>
            <ng-container *ngIf="config?.rental?.taxes?.length === 0">
              <mat-slide-toggle
                #toggleEl
                [checked]="false"
                (click)="$event.stopPropagation(); toggle.emit(config); toggleEl.toggle()"
                i18n
                >Status: {{ config?.status === 1 ? 'Active' : 'Inactive' }}</mat-slide-toggle
              >
            </ng-container>
          </div>
        </div>
        <div *ngIf="isHomeAway" class="row">
          <div class="col-sm-11">
            <mat-slide-toggle
              (click)="$event.stopPropagation()"
              [id]="config?.pkey"
              [checked]="config?.status === 1"
              (change)="toggle.emit(config)"
              i18n
            >
              Status: {{ config?.status === 1 ? 'Active' : 'Inactive' }}
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-content></ng-content>
</div>
